<template>
  <Header />
  <FullMap />
  <LocationMap />
  <Stations />
  <Footer />
</template>
<script>
import store from "@/store";
import Footer from "@/components/widgets/Footer.vue"; // @ is an alias to /src
import Header from "@/components/widgets/Header.vue"; // @ is an alias to /src
import Stations from "@/components/widgets/Stationinformations.vue"; // @ is an alias to /src
import LocationMap from "@/components/widgets/LocationMap.vue"; // @ is an alias to /src
import FullMap from "@/components/widgets/FullMap.vue"; // @ is an alias to /src
import { slugMe } from "@/constants/formater";

import i18n from "@/mixins/mixins";

export default {
  components: { Footer, Header, LocationMap, FullMap, Stations },
  props: ["name"],
  mixins: [i18n],
  setup() {
    return {
      slugMe,
    };
  },
  data() {
    return {
      env: process.env,
      stations: store.getters["stations/GET_STATIONS"],
    };
  },
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  },
};
</script>
